export default {
  training: {
    code: "Code",
    hours: "Number of hours",
    hours_learning: "Number of teaching hours",
    public: "Intended audience",
    comment: "Comment",
    registrants_number: "Number of registrants",
    publish_success: "Reference document successfully published!",
    publish_program_success: "Program successfully published!",
    rncp: {
      nsf_codes: "NSF Codes",
      form_codes: "Formacodes",
      rome_codes: "Rome Codes",
      targeted_activities: "Targeted activities",
      domains: "Domains",
      industry_sector_and_types_job: "Industry sector and job types",
      business_sectors: "Business sectors",
      types_of_jobs: "Job types",
      due_date: "Due date",
      previous_certification: "Previous certification",
      new_certification: "New certification",
      editing_competency_framework: "Editing competency framework",
      rncp_skills: "RNCP skills",
      ai_suggestions: "AI suggestions",
      skills_related: "Skills related to this competency block",
      missions_related: "Missions related to this competency block",
      ai_suggestions_related_skills: "AI Suggestions - Additional skills",
      ai_suggestions_related_missions: "AI Suggestions - Additional missions",
      relaunch_ai: "Relaunch (3 new)",
      triad: "Booklet,",
      badge: {
        rome: "ROME",
        rncp: "RNCP",
        triad: "Work-study booklet",
        job_offer: "job offers",
        offer: "offers",
        sources: "Sources",
        triads: "Booklets",
        confidence: "Confidence",
      },
      workflow: {
        skill_import_label: "Skills import",
        enrichment_import_label: "AI enrichment",
        publish_import_label: "Publication",
        waiting_status_label: "Upcoming",
        pending_status_label: "In progress",
        finished_status_label: "Completed",
        import_button_label: "Import",
        enrichment_button_label: "Enrich skills",
        publish_button_label: "Publish",
      },
      actions: {
        reimporting_skills: "Existing data detected",
      },
      modal: {
        text: "How would you like to proceed with the new import?",
        merge_button_title: "Merge",
        merge_button_text: "Keep existing data and only add new ones",
        crush_button_title: "Replace",
        crush_button_text: "Delete all existing data and replace with new ones",
        alert_title: "A template already exists for this training",
        alert_text: "How would you like to proceed with the new data?",
        submit: "Confirm import",
      },
      alert: {
        empty_rncp_warning_text:
          "To start importing data and create your first competency framework, you must specify an RNCP title from the training configuration form accessible by an administrator only.",
        referential_publish_title: "Publish a framework",
        referential_publish_sub_title: "Are you sure you want to publish this framework?",
        error: "Something went wrong, please try again later.",
        importing: "Data import in progress, please wait.",
        enriching: "Data enrichment in progress, please wait.",
        update_rncp: "Remember to update the RNCP code with each new publication",
        rncp_sheet_import: "Please import skills to display the RNCP title details of the training.",
        rncp_skill_import: "Please import skills to start configuring the training framework.",
        due_date_in_month: "Due in {month} months",
        due_date_in_day: "Due in {day} days",
        empty_skills:
          "No skills at the moment, please import from AI suggestions or add one\n" +
          "                  manually by clicking the + button",
        empty_missions:
          "No missions at the moment, please import from AI suggestions or add one\n" +
          "                  manually by clicking the + button",
        empty_suggestions: "No suggestions, please relaunch the AI to get new ones.",
        empty_block:
          "No competency block at the moment, please add one\n" + "                  manually by clicking the + button",
      },
      level: {
        niv3: "CAP/BEP (Level 3)",
        niv4: "BAC (Level 4)",
        niv5: "BAC+2 (Level 5)",
        niv7: "Master's degree (Level 7)",
        niv8: "Doctorate (Level 8)",
      },
      source_detail: {
        criticality: {
          title: "Criticality",
          low: "Keep an eye on",
          medium: "Emerging",
          high: "Rapidly emerging",
        },
        pertinence: "Relevance score",
        criteria: {
          title: "4 criteria selected",
          pertinence_f: "Frequency in job postings",
          pertinence_a: "Semantic alignment",
          pertinence_p: "Industry expertise",
          pertinence_d: "Distinctiveness",
        },
        justification: "Justification AI",
        referential_presence: "Inclusion in indexes",
        source: {
          rome: "ROME",
          esco: "ESCO",
          rncp: "RNCP",
          offres: "Job openings",
          offre: "Job opening",
          livret: "Booklet",
          marche: "Market",
        },
        source_offers: "Source offers",
        published_at: "Published on",
        view_offer: "View offer",
        present: "Present",
        absent: "Absent",
        offers_count: "{jobOfferCount} out of {jobOfferTotal} analyzed job postings mention this {type}.",
      },
    },
    program: {
      model: "Template",
      required: "Req/Opt",
      ects: "ECTS",
      coefficient_short: "Coeff.",
      ai_confidence: "AI confidence",
      target_audience: "Target audience",
      prerequisites: "Prerequisites",
      training_targets: "Training objectives",
      informations: "Practical information",
      general_informations: "General information",
      graduation: "Degree",
      route: "Path",
      rncp_code: "RNCP code",
      graduation_type: "Degree type",
      total_volume: "Total volume",
      ects_credits: "ECTS credits",
      add_files: "Drop your files",
      training_program: "Training program",
      duration: "Duration",
      modality: "Modality",
      pace: "Pace",
      location: "Location",
      professionalOutcomes: "Career prospects",
      extension_accepted_message: "Only PDF, DOC, DOCX, XLS, XLSX and MSWORD files are accepted",
      steps: {
        import: {
          title: "Program import",
          button: "Import",
        },
        publish: {
          title: "Program publication",
          button: "Publish",
        },
        incoming: "Upcoming",
        inprogress: "In progress",
        finished: "Completed",
      },
      actions: {
        reimporting_program: "Reimport the program?",
      },
      modal: {
        text: "A program already exists for this training. How would you like to proceed?",
        merge_button_title: "Keep and complete",
        merge_button_text: "Existing data will be kept, new data will be added.",
        crush_button_title: "Replace completely",
        crush_button_text: "All existing data will be deleted and replaced.",
        alert_title: "Important",
        alert_text: "This action will impact future published programs and associated trainings.",
        submit: "Confirm import",
        "general-info": "Edit general information",
        "target-audience": "Edit target audience and prerequisites",
        objectives: "Edit training objectives",
        "practical-info": "Edit practical information",
      },
      training_period: {
        heading: {
          code: "Code",
          label: "Label",
          type: "Type",
          required: "Req/Opt",
          hours: "Hours",
          ects: "ECTS",
          coef: "Coeff.",
          actions: "Actions",
        },
      },
      alert: {
        importing: "Data import in progress, please wait.",
        empty_semester:
          "No semesters at the moment, please add one\n" + "                  manually by clicking the + button",
        empty_unit:
          "No units or modules at the moment, please add\n" + "                  manually by clicking the + buttons",
        program_import: "Please import the program to start configuring the template",
        file_uploaded_success: "File imported successfully | {count} files imported successfully",
        file_upload_error: "Error importing files",
        note: "Note",
        note_text:
          "This information was automatically extracted from the PDF template. You can modify it by clicking the pencil icon.",
        warning_points: "Warning points",
        warning_points_text: "3 modules without code • 2 modules require verification",
        empty_general_informations: "Please import the program to display general information",
        program_publish_title: "Publish the training program",
        program_publish_sub_title: "Are you sure you want to publish this training program to all cohorts?",
        unit_missing_code: ({ plural, named }) =>
          plural([`${named("count")} unit without code`, `${named("count")} units without code`]),
        subject_missing_code: ({ plural, named }) =>
          plural([`${named("count")} module without code`, `${named("count")} modules without code`]),
        unit_need_validation: ({ plural, named }) =>
          plural([`${named("count")} unit requires verification`, `${named("count")} units requires verification`]),
        subject_need_validation: ({ plural, named }) =>
          plural([`${named("count")} module requires verification`, `${named("count")} modules requires verification`]),
        verification: "Data to be verified",
        low_confidence_score:
          "The AI has detected this module with {confidence}% confidence. Please check and correct the information below before confirming.",
      },
    },
    contact: {
      detail: {
        title: ({ named }) => `Contact details for ${named("name")}`,
      },
    },
    contract_list: "List of contracts",
    contacts: {
      success: "Contacts successfully saved!",
    },
    plan_contract: {
      baseline: 'To select the year you are working on, click "Activate"',
    },
  },
  employee: ({ plural }) => plural(["Employee", "Employees"]),
};
